// export default function useFormatNumber(
//   value: number | null | undefined,
// ): string {
//   if (value == null) return "0";
//   let formatted: string;
//   if (value >= 1000000000) {
//     formatted = (value / 1000000000).toFixed(1) + "B";
//   } else if (value >= 1000000) {
//     formatted = (value / 1000000).toFixed(1) + "M";
//   } else if (value >= 1000) {
//     formatted = (value / 1000).toFixed(1) + "K";
//   } else {
//     formatted = value.toString();
//   }
//   return formatted.replace(/\.0([BMK]?)$/, "$1");
// }

export default function useFormatNumber(
  value: number | null | undefined,
): string {
  if (value == null) return "0";

  let formatted: string;

  if (value >= 1_000_000_000) {
    formatted = Math.trunc((value / 1_000_000_000) * 100) / 100 + "B";
  } else if (value >= 1_000_000) {
    formatted = Math.trunc((value / 1_000_000) * 100) / 100 + "M";
  } else if (value >= 1_000) {
    formatted = Math.trunc((value / 1_000) * 100) / 100 + "K";
  } else if (value >= 1 && value <= 9) {
    formatted = "0" + value.toString();
  } else {
    // ✅ truncate to 2 decimals, NO rounding
    formatted = (Math.trunc(value * 100) / 100).toString();
  }

  return formatted.replace(/\.0+([BMK]?)$/, "$1");
}
